<template>
  <div id="creditsOutstandingPage">
    <CreditsOutstandingTable />
  </div>
</template>

<script>
import CreditsOutstandingTable from '@/components/CreditsOutstandingTable.vue';

export default {
  name: 'CreditsOutstanding',
  components: {
    CreditsOutstandingTable,
  },
};
</script>
